const RouteModelComponent = () => import('@/views/RouteModel/RouteModelView')

export default [
    {
        path:'/RouteModelIndex',
        name:'RouteModelRouter',
        component:RouteModelComponent
    }
]